import { getApiClient, initializeApiClient } from "../apiService";
export const GetMarksTableData = async (subTaskFlowGUID) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post("api/Marks/GetAllMarksBySubTaskGuid", {
    subTaskFlowGUID: subTaskFlowGUID,
  });

  return response;
};
